import React from 'react';
import { useTranslation } from 'react-i18next';
import { invoke } from '@tauri-apps/api/core';
import { Section } from '../settingsPrimitives';

/**
 * Settings → About → Developer: the "Open DevTools" button.
 *
 * Development builds only. A release build is compiled without Tauri's
 * devtools feature (card 39cf5e71, S12 — an inspector console can call every
 * command), so `open_devtools` refuses there and the button would be a dead
 * control. `npm start` / `tauri dev` run with NODE_ENV=development; every
 * `npm run build` — which is what a release packages — is production.
 */
export default function DeveloperSection() {
  const { t } = useTranslation();
  if (process.env.NODE_ENV === 'production') return null;
  return (
    <Section title="Developer">
      <div className="settings-resource-row">
        <div>
          <div className="settings-resource-label">Open DevTools</div>
          <div className="settings-resource-desc">Opens the WebView inspector for this window.</div>
        </div>
        <button
          type="button"
          className="settings-resource-btn"
          onClick={() => invoke('open_devtools').catch((err) => console.error('Failed to open devtools:', err))}
          aria-label="Open DevTools"
        >
          {t('settings.open')}
        </button>
      </div>
    </Section>
  );
}
